import React from 'react';

export default function Error() {
  return <div>Error, Invalid URL</div>;
}
